import { createDataSelectors } from "@app/modules/app.reducers";
import { ProjectCategory } from "@ea/shared_types/types";

export const projectCategoryDataSelectors =
  createDataSelectors<ProjectCategory>()("projectCategory");
